import { ReactNode } from "react";

export enum ToggleType {
  icon = "icon",
  text = "text"
}

export enum ToggleLayout {
  grid = "grid",
  list = "list",
  tree = "tree",
  custom = "custom"
}

export interface ToggleProps {
  /**
   * The type of toggle - either icon or text
   * @default "text"
   */
  toggleType?: keyof typeof ToggleType;
  /**
   * The layout variant for icon toggles
   */
  layout?: keyof typeof ToggleLayout;
  /**
   * Text content for text toggles
   */
  text?: ReactNode;
  /**
   * Custom icon for custom layout
   */
  customIcon?: ReactNode;
  /**
   * Whether the toggle is disabled
   */
  disabled?: boolean;
  /**
   * Whether the toggle is pressed/active
   */
  pressed?: boolean;
  /**
   * Callback fired when the pressed state changes
   * @param pressed The new pressed state
   */
  onPressedChange: (pressed: boolean) => void;
  /**
   * Optional class name for styling
   */
  className?: string;
}
